import React from "react";
import {isSubmitButton} from "../FormElements.js";

/* "this" context refers to FormComponent instance */
export function ButtonInstanceHandler(o){
    if(isSubmitButton(o.type)){
        o = React.cloneElement(o, {
            onClick : (e)=>{
                this.setState({
                    isSubmitRequested:true
                });
                this.validate();
                if(!(this.errorObj && this.errorObj.validationError)){
                    this.props.onSuccess && this.props.onSuccess(this.values);
                }
                e.preventDefault();
            },
            disabled: this.state.validationError
        })
    }
    return o;
}
